var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Particles',{attrs:{"id":"tsparticles","options":{
          background: {
              color: {
                  value: '#6363cf'
              }
          },
          fpsLimit: 60,
          interactivity: {
              detectsOn: 'canvas',
              events: {
                  onHover: {
                      enable: true,
                      mode: 'repulse'
                  },
                  resize: true
              },
              modes: {
                  bubble: {
                      distance: 400,
                      duration: 2,
                      opacity: 0.8,
                      size: 40,
                      speed: 3
                  },
                  push: {
                      quantity: 4
                  },
                  repulse: {
                      distance: 200,
                      duration: 0.4
                  }
              }
          },
          particles: {
              color: {
                  value: '#ffffff'
              },
              links: {
                  color: '#ffffff',
                  distance: 150,
                  enable: true,
                  opacity: 0.5,
                  width: 1
              },
              collisions: {
                  enable: true
              },
              move: {
                  direction: 'none',
                  enable: true,
                  outMode: 'bounce',
                  random: false,
                  speed: 6,
                  straight: false
              },
              number: {
                  density: {
                      enable: true,
                      value_area: 800
                  },
                  value: 80
              },
              opacity: {
                  value: 0.5
              },
              shape: {
                  type: 'circle'
              },
              size: {
                  random: true,
                  value: 5
              }
          },
          detectRetina: true
      }}}),_c('router-view'),_c('v-footer',{staticClass:"justify-center",attrs:{"dir":"ltr","fixed":""}},[_c('v-col',{staticClass:"text-center"},[_c('v-spacer'),_c('div',[_vm._v("\n          Copyright © 2020 - "+_vm._s(new Date().getFullYear())+"\n          "),_c('a',{attrs:{"href":"https://negarshowroom.com","target":"_blank"}},[_vm._v("Negar Showroom")]),_vm._v(". All rights reserved.\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }